import {
  Box,
  TextField,
  TextFieldProps,
  Grid,
  Switch,
  MenuItem,
  Typography,
  Select,
  FormControl,
  InputLabel,
} from "@mui/material";
import React, { FC, useEffect, useId, useState } from "react";
import { styled } from "@mui/material/styles";
import { Dimension, Units, toUnits, convert } from "./util";
import interpolate from "../../util/interpolate";
import { IDimensionsTranslations } from "../../types";

const StyledTextField = styled((props: TextFieldProps) => (
  <TextField {...props} />
))(({ theme }) => ({
  width: "110px",

  "& .MuiFormHelperText-root": {
    margin: 4,
    marginRight: 0,
    fontSize: 10,

    [theme.breakpoints.down("md")]: {
      fontSize: 9,
    },
  },

  [theme.breakpoints.down("md")]: {
    width: "100px",
  },
}));

export interface DimensionsProps {
  width: number;
  height: number;
  units: Units;
  showInches?: boolean;

  displayAs: Units;

  options: {
    title: string;
    width: number;
    height: number;
    units: Units;
  }[];

  onChangeConfirmed: (
    newWidth: number,
    newHeight: number,
    newUnit: Units
  ) => void;
  onError?: (hasError: boolean) => void;

  translations: IDimensionsTranslations;
}

export const DimensionsSelect: FC<DimensionsProps> = (props) => {
  const id = useId();
  const labelId = useId();
  const { units } = props;

  const [displayAs, setDisplayAs] = useState(props.displayAs || "cm");
  const [width, setWidth] = useState(props.width.toString());
  const [height, setHeight] = useState(props.height.toString());
  const widthNum = parseFloat(width);
  const heightNum = parseFloat(height);

  //   useEffect(() => {
  //     if (errors) {
  //       return;
  //     }

  //     props.onChangeConfirmed(widthNum, heightNum, displayAs);
  //   }, [errors, widthNum, heightNum, displayAs]);

  const t = interpolate(props.translations);
  const label = "Button/Badge Size";

  return (
    <Grid container alignItems="center" sx={{ position: "relative" }}>
      <FormControl fullWidth>
        <InputLabel id={labelId}>{label}</InputLabel>
        <Select
          labelId={labelId}
          id={id}
          value={convert(props.units, props.displayAs, props.width)}
          label={label}
          sx={{
            maxWidth: {
              xs: "100%",
              md: "276px",
            },
          }}
          onChange={(ev) => {
            props.onChangeConfirmed(+ev.target.value, +ev.target.value, "mm");
          }}
        >
          {props.options.map((opt) => {
            return (
              <MenuItem key={opt.title} value={opt.width}>
                {opt.title}
              </MenuItem>
            );
          })}
        </Select>
      </FormControl>
    </Grid>
  );
};
